<div class="flex mb-4 items-center justify-between">
	<div class="flex gap-4 items-center">
		<h5 class="mb-0">Deductions</h5>
		<div class="flex flex-col relative">
			<app-button
				[icon]="ICON.ADD"
				(clickOutside)="hideDropdown()"
				(onClick)="toggleDropdown()"
				size="small"
			>
				Add item
			</app-button>
			<app-dropdown-options
				[show]="showDropdownOptions"
				[itemGroups]="[{ items }]"
				(onSelect)="onSelect($event)"
				xposition="right"
				yposition="bottom"
				[dropdownClasses]="'max-h-60'"
				marginTop="10px"
			></app-dropdown-options>
		</div>
	</div>
</div>

<ul class="flex flex-col my-3 gap-4 overflow-auto py-2">
	<ng-container
		*ngFor="
			let item of _trustLedgerItem?.itemizedFees;
			let i = index;
			trackBy: itemsTrackBy
		"
	>
		<li
			class="grid grid-cols-2 gap-2"
			[ngClass]="isEditDescriptionList[i] ? 'items-start' : 'items-center'"
		>
			<div class="flex items-center gap-2">
				<app-button
					*ngIf="!isEditDescriptionList[i]"
					btn="tertiary"
					[icon]="ICON.DELETE"
					[holdable]="true"
					(onClick)="removeItem(i)"
				>
				</app-button>
				<app-input
					*ngIf="isEditDescriptionList[i]; else itemDescription"
					class="flex-1"
					[(ngModel)]="item.description"
					[placeholder]="getPlaceholder(item.type)"
					[required]="true"
					[name]="'name-' + i"
					[submitted]="submitted"
				>
				</app-input>
				<ng-template #itemDescription>
					<span>{{ item.description }}</span>
				</ng-template>
			</div>
			<app-input
				type="cents"
				[startIcon]="ICON.DOLLAR"
				[required]="true"
				[ngModel]="item.amount"
				(ngModelChange)="item.amount = $event"
				(debounceTime)="(100)"
				(debounce)="isEditDescriptionList[i] ? '' : updateItemizedFees()"
				[name]="'amount-' + i"
				[submitted]="submitted"
				[disabled]=""
				#amountInput
			>
			</app-input>
			<div class="flex justify-end gap-2" *ngIf="isEditDescriptionList[i]">
				<app-button btn="secondary" size="small" (onClick)="removeItem(i)"
					>Cancel</app-button
				>
				<app-button
					btn="primary"
					(onClick)="onDescriptionSave(i, amountInput)"
					size="small"
					>Save</app-button
				>
			</div>
		</li>
	</ng-container>
	<div class="flex justify-left text-sm text-grey" *ngIf="!hasItemizedFees">
		There are no deductions, add a new one
	</div>
</ul>

<div class="flex flex-row justify-between items-center mt-5">
	<p class="text font-bold">{{ _trustLedgerItem.description }}</p>
	<p class="text font-bold">
		{{ netSalePriceAmount | centsToDollars }}
	</p>
</div>
